(function () {
  var VERSION = "20260710-dog-badge-r7-cart-exclusion";
  if (window.__tk9DogOfferTeaserVersion === VERSION) return;
  window.__tk9DogOfferTeaserVersion = VERSION;

  // Retire cached teaser generations that may still be running from a stale
  // Shopify page-cache shard. The last predecessor polls v5; this runtime owns
  // v6 so both cannot keep rebuilding the same badge after recovery loads.
  try {
    window.localStorage.setItem("tk9_dog_offer_teaser", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser2", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser3", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser4", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser5", "off");
  } catch (error) {}

  var config = Object.assign({
    enabled: true,
    imageUrl: "",
    successImageUrl: "",
    successShowMs: 9000,
    label: "REVEAL OFFER",
    openingLabel: "OPENING...",
    popupId: "",
    popupSessionKey: "tk9_dog_offer_teaser_active_popup",
    killParam: "tk9_dog_teaser2",
    legacyKillParam: "tk9_dog_teaser",
    storageKey: "tk9_dog_offer_teaser6",
    dismissStorageKey: "tk9_dog_offer_teaser2_dismissed",
    reentryStorageKey: "tk9_dog_offer_teaser2_reentry",
    frameSelector: "iframe#ps__widget",
    suppressNativeBubble: true,
    stickySelector: [
      "#sticky-add-to-cart",
      ".sticky-add-to-cart",
      ".tk9-stage-dr__stickybar",
      ".tk9-stage--float-dock .tk9-stage__dock",
      ".tk9-stage__dock",
      ".bw-mobile-cta",
      "#PBarNextFrameWrapper",
      "[data-sticky-cart]",
      "[data-sticky-add-to-cart]",
      "[data-tk9-sticky-cart]",
      "[class*='sticky-cart']",
      "[class*='stickybar']",
      "[class*='sticky-bar']",
      "[class*='sticky_atc']",
      "[class*='sticky-atc']",
      "[class*='bottom-cta']",
      "[class*='bottom_bar']",
      "[class*='fixed-bottom']",
      "[class*='fixed_bottom']",
      "[class*='mobile-cta']"
    ].join(", "),
    nativeFindOptions: {
      triggerType: "Delay",
      respectPage: true,
      respectSubscriber: false,
      respectCountry: true,
      respectPlatform: true,
      respectStatus: false
    },
    nativeFindTriggerTypes: ["Delay", "Custom"],
    findRetryMs: 750,
    findMaxAttempts: 40,
    openVerifyMs: 8000,
    openMaxAttempts: 2,
    syncMs: 700
  }, window.TeamK9DogOfferTeaserConfig || {});

  function readParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return String(params.get(name) || "").toLowerCase();
    } catch (error) {
      return "";
    }
  }

  var killParam = readParam(config.killParam);
  var legacyParam = readParam(config.legacyKillParam);
  var forceMode = killParam === "force";

  function isCartPath() {
    var path = String(window.location.pathname || "/").replace(/\/+$/, "") || "/";
    return path === "/cart" || /^\/[a-z]{2}(?:-[a-z]{2})?\/cart$/i.test(path);
  }

  function isDisabled() {
    if (isCartPath()) return true;
    if (killParam === "0" || killParam === "off" || killParam === "false") return true;
    if (legacyParam === "0" || legacyParam === "off" || legacyParam === "false") return true;
    if (killParam === "1" || killParam === "on" || forceMode) return false;
    try {
      return String(window.localStorage.getItem(config.storageKey) || "").toLowerCase() === "off";
    } catch (error) {
      return false;
    }
  }

  if (!config.enabled || !config.imageUrl || isDisabled()) return;

  var container = null;
  var openButton = null;
  var closeButton = null;
  var dogImage = null;
  var pill = null;
  var styleTag = null;
  function storedPopupId() {
    try {
      return String(window.sessionStorage.getItem(config.popupSessionKey) || "");
    } catch (error) {
      return "";
    }
  }

  var popupId = storedPopupId();
  var popupReady = Boolean(popupId);
  var findInFlight = false;
  var findAttempts = 0;
  var pendingOpen = false;
  var dismissedThisSession = false;
  var reentryThisSession = false;
  var successActive = false;
  var successTimer = 0;
  var testFlashTimer = 0;
  var lastPlacementKey = "";
  var syncQueued = false;
  var hiddenBubble = null;
  var openRequestedAt = 0;
  var popupOpen = false;
  var closeGuardUntil = 0;
  var openAttempt = 0;
  var openVerifyTimer = 0;
  var lastOpenPointerDownAt = 0;

  function setQaState(name, value) {
    if (!forceMode || !container) return;
    container.setAttribute("data-tk9-qa-" + name, String(value == null ? "" : value));
  }

  function setOpeningState(active) {
    if (container) container.classList.toggle("is-opening", Boolean(active));
    if (openButton) {
      if (active) openButton.setAttribute("aria-busy", "true");
      else openButton.removeAttribute("aria-busy");
    }
    if (pill && !successActive) pill.textContent = active ? config.openingLabel : config.label;
  }

  function rememberPopupId(nextPopupId) {
    var normalizedId = nextPopupId == null ? "" : String(nextPopupId);
    if (!normalizedId) return false;
    popupId = normalizedId;
    popupReady = true;
    try {
      window.sessionStorage.setItem(config.popupSessionKey, normalizedId);
    } catch (error) {}
    return true;
  }

  function forgetPopupId() {
    popupId = "";
    popupReady = false;
    try {
      window.sessionStorage.removeItem(config.popupSessionKey);
    } catch (error) {}
  }

  function isDismissed() {
    if (dismissedThisSession) return true;
    try {
      return window.sessionStorage.getItem(config.dismissStorageKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function rememberDismissed() {
    dismissedThisSession = true;
    reentryThisSession = false;
    try {
      window.sessionStorage.setItem(config.dismissStorageKey, "1");
      window.sessionStorage.removeItem(config.reentryStorageKey);
    } catch (error) {}
  }

  function isReentryEnabled() {
    if (reentryThisSession) return true;
    try {
      return window.sessionStorage.getItem(config.reentryStorageKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function enableReentry() {
    reentryThisSession = true;
    try {
      window.sessionStorage.setItem(config.reentryStorageKey, "1");
    } catch (error) {}
  }

  // ---------- Postscript native popup API ----------

  function postscriptPopups() {
    var postscript = window.postscript;
    if (!postscript || typeof postscript !== "object") return null;
    var popups = postscript.popups;
    if (!popups || typeof popups.find !== "function" || typeof popups.open !== "function") return null;
    return popups;
  }

  function findEligiblePopup(popups) {
    var baseOptions = Object.assign({}, config.nativeFindOptions || {});
    var triggerTypes = Array.isArray(config.nativeFindTriggerTypes)
      ? config.nativeFindTriggerTypes.slice()
      : [baseOptions.triggerType || "Delay"];
    triggerTypes = triggerTypes.filter(function (value, index, values) {
      return value && values.indexOf(value) === index;
    });
    if (!triggerTypes.length) triggerTypes = ["Delay"];

    function tryTrigger(index) {
      if (index >= triggerTypes.length) return Promise.resolve(undefined);
      var options = Object.assign({}, baseOptions, { triggerType: triggerTypes[index] });
      return Promise.resolve(popups.find(options)).then(function (foundId) {
        return foundId || tryTrigger(index + 1);
      });
    }

    return tryTrigger(0);
  }

  function findPopup() {
    if (findInFlight || popupReady || (isDismissed() && !forceMode)) return;
    var popups = postscriptPopups();
    if (!popups) {
      setQaState("find", "sdk-missing");
      return;
    }
    setQaState("find", "searching");
    findInFlight = true;
    findAttempts += 1;
    Promise.resolve()
      .then(function () {
        return findEligiblePopup(popups);
      })
      .then(function (foundId) {
        setQaState("find", foundId ? "found" : "none");
        setQaState("found-id", foundId || "");
        if (foundId) {
          rememberPopupId(foundId);
          if (pendingOpen) {
            window.setTimeout(openPopupNow, 0);
          }
        }
        queueSync();
      })
      .catch(function (error) {
        setQaState("find", "error");
        setQaState("find-error", error && error.message ? error.message : "unknown");
      })
      .finally(function () {
        findInFlight = false;
      });
  }

  function clearOpenVerification() {
    window.clearTimeout(openVerifyTimer);
    openVerifyTimer = 0;
  }

  function popupLooksOpen() {
    if (popupOpen || popupOwnsFrame()) return true;
    var frame = document.querySelector(config.frameSelector);
    if (!frame) return false;
    var rect = frame.getBoundingClientRect();
    var frameStyle = window.getComputedStyle(frame);
    if (frameStyle.display === "none" || frameStyle.visibility === "hidden") return false;
    return rect.width > 380 || rect.height > 220;
  }

  function verifyOpenAttempt() {
    openVerifyTimer = 0;
    if (popupLooksOpen()) {
      setQaState("open", "confirmed");
      pendingOpen = false;
      setOpeningState(false);
      return;
    }
    if (!pendingOpen) return;
    openRequestedAt = 0;
    setQaState("open", "missed");
    forgetPopupId();
    if (openAttempt >= config.openMaxAttempts) {
      pendingOpen = false;
      setOpeningState(false);
      queueSync();
      return;
    }
    findPopup();
  }

  function scheduleOpenVerification() {
    clearOpenVerification();
    openVerifyTimer = window.setTimeout(verifyOpenAttempt, config.openVerifyMs);
  }

  function openPopupNow() {
    var popups = postscriptPopups();
    if (!popupId) {
      pendingOpen = true;
      findPopup();
      return false;
    }
    if (!popups) {
      pendingOpen = true;
      return false;
    }
    pendingOpen = true;
    openRequestedAt = Date.now();
    openAttempt += 1;
    setQaState("open", "attempting");
    setQaState("open-id", popupId);
    setQaState("open-attempt", openAttempt);
    releaseBubble();

    function handleOpenFailure(error) {
      if (!pendingOpen && popupOpen) return;
      setQaState("open", "error");
      setQaState("open-error", error && error.message ? error.message : "unknown");
      clearOpenVerification();
      openRequestedAt = 0;
      forgetPopupId();
      if (openAttempt >= config.openMaxAttempts) {
        pendingOpen = false;
        setOpeningState(false);
      } else {
        findPopup();
      }
    }

    try {
      // The dog is already the visitor's explicit micro-yes. A prior soft-close
      // must not turn that click into Postscript's compact teaser state.
      var openResult = popups.open(popupId, {
        activePopupBehavior: "DISMISS_WHEN_SOFT_CLOSED",
        respectPopupStatus: false,
        respectCooldown: false
      });
      if (openResult && typeof openResult.then === "function") {
        Promise.resolve(openResult).catch(handleOpenFailure);
      }
      scheduleOpenVerification();
      return true;
    } catch (error) {
      handleOpenFailure(error);
      return false;
    }
  }

  function handleOpenClick(event) {
    if (event && event.type === "click" && Date.now() - lastOpenPointerDownAt < 800) {
      if (event.preventDefault) event.preventDefault();
      setQaState("synthetic-click", "coalesced");
      return;
    }
    if (Date.now() < closeGuardUntil) {
      if (event && event.preventDefault) event.preventDefault();
      return;
    }
    if (event && event.preventDefault) event.preventDefault();
    if (pendingOpen && (openVerifyTimer || findInFlight || openRequestedAt)) {
      setQaState("repeat-click", "coalesced");
      return;
    }
    setOpeningState(true);
    preloadSuccessImage();
    pendingOpen = true;
    popupOpen = false;
    openAttempt = 0;
    clearOpenVerification();
    if (popupReady) {
      openPopupNow();
      return;
    }
    findPopup();
  }

  function handleOpenPointerDown(event) {
    if (event && event.isPrimary === false) return;
    if (event && typeof event.button === "number" && event.button !== 0) return;
    lastOpenPointerDownAt = Date.now();
    handleOpenClick(event);
  }

  function flashTestFeedback() {
    if (!pill) return;
    window.clearTimeout(testFlashTimer);
    pill.textContent = "CLICK OK (TEST)";
    container.classList.add("is-test-open");
    testFlashTimer = window.setTimeout(function () {
      pill.textContent = config.label;
      container.classList.remove("is-test-open");
    }, 1600);
  }

  function handleCloseClick(event) {
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();
    if (event && event.stopImmediatePropagation) event.stopImmediatePropagation();
    closeGuardUntil = Date.now() + 800;
    rememberDismissed();
    pendingOpen = false;
    setOpeningState(false);
    clearOpenVerification();
    hideTeaser();
    queueSync();
  }

  function eventPoint(event) {
    var source = event && event.touches && event.touches[0]
      ? event.touches[0]
      : event && event.changedTouches && event.changedTouches[0]
        ? event.changedTouches[0]
        : event;
    if (!source || typeof source.clientX !== "number" || typeof source.clientY !== "number") return null;
    return { x: source.clientX, y: source.clientY };
  }

  function handleCloseHitZone(event) {
    if (!closeButton || !closeButton.isConnected) return;
    var path = event && event.composedPath ? event.composedPath() : [];
    var directlyTargeted = path.indexOf(closeButton) !== -1;
    var point = eventPoint(event);
    var rect = closeButton.getBoundingClientRect();
    var insideHitbox = point &&
      point.x >= rect.left && point.x <= rect.right &&
      point.y >= rect.top && point.y <= rect.bottom;
    if (directlyTargeted || insideHitbox) handleCloseClick(event);
  }

  // ---------- Postscript mini-bubble suppression ----------
  // While our teaser is on screen (or dismissed for the session), Postscript's
  // own minimized launcher bubble is hidden in place: visibility + pointer
  // events only, never geometry, never opacity-but-clickable. Anything larger
  // than bubble size (an expanded/opening popup) is never touched, and any
  // open request releases the bubble first.

  function popupOwnsFrame() {
    if (document.querySelector("postscript-popup")) return true;
    return document.documentElement.classList.contains("ps-scroll-lock") ||
      document.body.classList.contains("ps-scroll-lock");
  }

  function isVisibleBubble(frame) {
    if (!frame) return false;
    var rect = frame.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    if (rect.width > 380 || rect.height > 220) return false;
    var frameStyle = window.getComputedStyle(frame);
    if (frameStyle.display === "none" || frameStyle.visibility === "hidden") return false;
    if (Number(frameStyle.opacity || 1) <= 0) return false;
    return true;
  }

  function suppressBubble(frame) {
    if (!frame || frame.getAttribute("data-tk9-bubble-suppressed") === VERSION) return;
    frame.__tk9BubbleStyleSnapshot = {
      visibility: frame.style.getPropertyValue("visibility"),
      visibilityPriority: frame.style.getPropertyPriority("visibility"),
      pointerEvents: frame.style.getPropertyValue("pointer-events"),
      pointerEventsPriority: frame.style.getPropertyPriority("pointer-events")
    };
    frame.setAttribute("data-tk9-bubble-suppressed", VERSION);
    frame.style.setProperty("visibility", "hidden", "important");
    frame.style.setProperty("pointer-events", "none", "important");
    hiddenBubble = frame;
  }

  function hideBubble() {
    if (!config.suppressNativeBubble) {
      releaseBubble();
      return;
    }
    // The launcher and expanded popup reuse the same iframe. Release our
    // styles as soon as Postscript starts opening or locks page scrolling.
    if ((openRequestedAt && Date.now() - openRequestedAt < 10000) || popupOwnsFrame()) {
      releaseBubble();
      return;
    }
    var frame = document.querySelector(config.frameSelector);
    if (frame && frame.getAttribute("data-tk9-bubble-suppressed") === VERSION) {
      var suppressedRect = frame.getBoundingClientRect();
      if (suppressedRect.width > 380 || suppressedRect.height > 220) releaseBubble();
      return;
    }
    if (!isVisibleBubble(frame)) {
      releaseBubble();
      return;
    }
    suppressBubble(frame);
  }

  function releaseBubble() {
    var frame = hiddenBubble || document.querySelector(config.frameSelector);
    hiddenBubble = null;
    if (!frame || frame.getAttribute("data-tk9-bubble-suppressed") !== VERSION) return;
    var snapshot = frame.__tk9BubbleStyleSnapshot || {};
    if (snapshot.visibility) {
      frame.style.setProperty("visibility", snapshot.visibility, snapshot.visibilityPriority || "");
    } else {
      frame.style.removeProperty("visibility");
    }
    if (snapshot.pointerEvents) {
      frame.style.setProperty("pointer-events", snapshot.pointerEvents, snapshot.pointerEventsPriority || "");
    } else {
      frame.style.removeProperty("pointer-events");
    }
    frame.removeAttribute("data-tk9-bubble-suppressed");
    try {
      delete frame.__tk9BubbleStyleSnapshot;
    } catch (error) {}
  }

  // ---------- success dog ----------

  var successImagePreloaded = false;

  function preloadSuccessImage() {
    if (successImagePreloaded || !config.successImageUrl) return;
    successImagePreloaded = true;
    var preload = new Image();
    preload.src = config.successImageUrl;
  }

  function currentDogImageUrl() {
    return successActive && config.successImageUrl ? config.successImageUrl : config.imageUrl;
  }

  function updateDogImage() {
    if (!dogImage) return;
    var nextSrc = currentDogImageUrl();
    if (dogImage.dataset.tk9Src !== nextSrc) {
      dogImage.src = nextSrc;
      dogImage.dataset.tk9Src = nextSrc;
    }
    if (container) container.classList.toggle("is-success", Boolean(successActive && config.successImageUrl));
  }

  function clearSuccessDog() {
    successActive = false;
    window.clearTimeout(successTimer);
    successTimer = 0;
    updateDogImage();
  }

  function dismissSuccessDog() {
    clearSuccessDog();
    rememberDismissed();
    hideTeaser();
    queueSync();
  }

  function showSuccessDog(durationMs) {
    if (!config.successImageUrl) return false;
    successActive = true;
    updateDogImage();
    window.clearTimeout(successTimer);
    successTimer = window.setTimeout(dismissSuccessDog, Number(durationMs) > 0 ? Number(durationMs) : config.successShowMs);
    return true;
  }

  function handleSuccessEvent(event) {
    var detail = event && event.detail;
    var duration = detail && typeof detail === "object" ? (detail.durationMs || detail.duration || 0) : 0;
    showSuccessDog(duration);
  }

  function maybeHandlePostscriptSuccessMessage(event) {
    var data = event && event.data;
    var text = "";
    if (typeof data === "string") {
      text = data;
    } else {
      try {
        text = JSON.stringify(data);
      } catch (error) {
        text = "";
      }
    }
    text = text.toLowerCase();
    if (!text) return;
    if (!/(postscript|ps__|popup|subscriber|subscription|optin|opt-in|sms|email)/.test(text)) return;
    if (!/(success|submitted|complete|completed|confirmed|subscribed|opted|opted_in|opted-in)/.test(text)) return;
    showSuccessDog();
  }

  function handlePostscriptPopupEvent(event) {
    var detail = event && event.detail;
    if (!detail || !detail.type) return;
    var eventPopupId = detail.popupId == null ? "" : String(detail.popupId);
    setQaState("event", detail.type);
    setQaState("event-id", eventPopupId);
    if (eventPopupId) rememberPopupId(eventPopupId);

    if (detail.type === "impression") {
      popupOpen = true;
      pendingOpen = false;
      openAttempt = 0;
      setOpeningState(false);
      clearOpenVerification();
      releaseBubble();
      hideTeaser();
      return;
    }

    if (detail.type !== "close") return;
    openRequestedAt = 0;
    popupOpen = false;
    pendingOpen = false;
    openAttempt = 0;
    setOpeningState(false);
    clearOpenVerification();
    if (!successActive) enableReentry();
    queueSync();
  }

  // ---------- sticky add-to-cart detection ----------

  function isDisplayable(node) {
    if (!node) return false;
    var rect = node.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    var nodeStyle = window.getComputedStyle(node);
    if (nodeStyle.display === "none" || nodeStyle.visibility === "hidden") return false;
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function isBottomAnchoredBar(node) {
    var rect = node.getBoundingClientRect();
    var nodeStyle = window.getComputedStyle(node);
    if (nodeStyle.position !== "fixed" && nodeStyle.position !== "sticky") return false;
    var mobile = window.innerWidth <= 640;
    var bottomSlack = mobile ? 96 : 72;
    if (rect.bottom < window.innerHeight - bottomSlack) return false;
    return rect.top < window.innerHeight && rect.bottom > window.innerHeight * 0.45;
  }

  function overlapsTeaserZone(node) {
    if (window.innerWidth <= 640) return true;
    var rect = node.getBoundingClientRect();
    var teaserLeft = 18;
    var teaserRight = 18 + 230 + 36;
    var overlapsLeft = rect.left < teaserRight && rect.right > teaserLeft;
    var isBroadBar = rect.width >= window.innerWidth * 0.55;
    return overlapsLeft || isBroadBar;
  }

  function stickyBarHeight() {
    var nodes;
    try {
      nodes = document.querySelectorAll(config.stickySelector);
    } catch (error) {
      return 0;
    }
    var best = 0;
    for (var index = 0; index < nodes.length; index += 1) {
      var node = nodes[index];
      if (!node || node === container || (container && container.contains(node))) continue;
      if (node.id === "ps__widget") continue;
      if (!isDisplayable(node) || !isBottomAnchoredBar(node) || !overlapsTeaserZone(node)) continue;
      var height = Math.max(0, window.innerHeight - node.getBoundingClientRect().top);
      if (height > best) best = height;
    }
    return best;
  }

  function placement() {
    var mobile = window.innerWidth <= 640;
    var stickyHeight = stickyBarHeight();
    var previewBar = document.getElementById("PBarNextFrameWrapper");
    var previewBarVisible = isDisplayable(previewBar) && isBottomAnchoredBar(previewBar);
    var overlap = mobile || previewBarVisible ? 0 : 8;
    // Bounded: never park the dog above 42% of the viewport no matter what
    // the sticky detection matched.
    var maxBottom = Math.round(window.innerHeight * 0.42);
    var bottom = stickyHeight > 0
      ? Math.min(Math.max(0, Math.round(stickyHeight - overlap)), maxBottom)
      : (mobile ? -5 : -6);
    return {
      mobile: mobile,
      left: mobile ? 10 : 18,
      bottom: bottom,
      width: mobile ? 180 : 230,
      height: mobile ? 78 : 98
    };
  }

  // ---------- DOM ----------

  function ensureStyle() {
    if (styleTag || document.getElementById("tk9-dog-offer-teaser2-style")) return;
    styleTag = document.createElement("style");
    styleTag.id = "tk9-dog-offer-teaser2-style";
    styleTag.textContent = [
      "#tk9-dog-offer-teaser2{position:fixed;left:18px;bottom:-6px;width:230px;height:98px;z-index:2147483000;font-family:inherit;overflow:visible;contain:layout style}",
      "#tk9-dog-offer-teaser2.is-hidden{display:none}",
      "#tk9-dog-offer-teaser2 *{box-sizing:border-box}",
      "#tk9-dog-offer-teaser2 button{appearance:none;-webkit-appearance:none;background:transparent;border:0;padding:0;margin:0;font:inherit}",
      ".tk9-dog-offer-teaser2__open{position:absolute;inset:0;display:block;width:100%;height:100%;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent}",
      ".tk9-dog-offer-teaser2__open:focus-visible{outline:2px solid #fff0c2;outline-offset:2px;border-radius:14px}",
      ".tk9-dog-offer-teaser2__dog-mask{position:absolute;left:0;bottom:0;width:214px;height:72px;overflow:hidden;pointer-events:none;filter:drop-shadow(0 10px 16px rgba(5,20,30,.22)) drop-shadow(0 1px 0 rgba(255,255,255,.66))}",
      ".tk9-dog-offer-teaser2__dog{position:absolute;left:0;bottom:-4px;width:204px;height:auto;max-width:none}",
      "#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__dog{left:9px;bottom:-10px;width:183px}",
      "#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__blink,#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__wink{display:none!important}",
      ".tk9-dog-offer-teaser2__blink{position:absolute;z-index:2;width:27px;height:18px;border-radius:999px;background:radial-gradient(ellipse at 50% 42%,rgba(128,74,38,.98) 0%,rgba(83,45,28,.98) 58%,rgba(24,15,13,.98) 100%);box-shadow:inset 0 -2px 2px rgba(17,10,8,.75),0 0 0 1px rgba(20,12,10,.22);opacity:0;pointer-events:none;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(.05);transform-origin:50% 50%;animation:tk9-dog2-blink 11.5s infinite;animation-delay:1.35s}",
      ".tk9-dog-offer-teaser2__blink--left{left:44px;top:22px;--tk9-blink-rotate:4deg}",
      ".tk9-dog-offer-teaser2__blink--right{left:126px;top:22px;--tk9-blink-rotate:-5deg}",
      ".tk9-dog-offer-teaser2__wink{position:absolute;z-index:3;left:126px;top:22px;width:27px;height:18px;border-radius:999px;background:radial-gradient(ellipse at 50% 42%,rgba(128,74,38,.98) 0%,rgba(83,45,28,.98) 58%,rgba(24,15,13,.98) 100%);box-shadow:inset 0 -2px 2px rgba(17,10,8,.75),0 0 0 1px rgba(20,12,10,.22);opacity:0;pointer-events:none;transform:rotate(-5deg) scaleY(.05);transform-origin:50% 50%;animation:tk9-dog2-wink 57.5s infinite}",
      ".tk9-dog-offer-teaser2__pill{position:absolute;left:72px;top:8px;display:flex;align-items:center;justify-content:center;min-width:146px;min-height:29px;padding:8px 12px;border-radius:999px;background:#162846;color:#fff;border:1px solid rgba(255,255,255,.76);box-shadow:0 10px 18px rgba(5,20,30,.22),inset 0 1px 0 rgba(255,255,255,.18);font-size:10px;font-weight:900;line-height:1;letter-spacing:0;text-transform:uppercase;white-space:nowrap;text-shadow:0 1px 0 rgba(0,0,0,.16);pointer-events:none}",
      "#tk9-dog-offer-teaser2.is-test-open .tk9-dog-offer-teaser2__pill{background:#1d6a3a}",
      "#tk9-dog-offer-teaser2.is-opening .tk9-dog-offer-teaser2__pill{background:#203a63}",
      ".tk9-dog-offer-teaser2__close{position:absolute;left:206px;top:-10px;display:flex;align-items:center;justify-content:center;width:44px;height:44px;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;z-index:2}",
      ".tk9-dog-offer-teaser2__close:before{content:'x';display:flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:999px;border:1px solid rgba(255,255,255,.72);background:#162846;color:#fff;box-shadow:0 4px 9px rgba(5,20,30,.18);font:900 11px/1 Arial,sans-serif}",
      ".tk9-dog-offer-teaser2__close:hover:before{background:#213b65}",
      ".tk9-dog-offer-teaser2__close:focus-visible{outline:2px solid #fff0c2;outline-offset:2px;border-radius:999px}",
      "@keyframes tk9-dog2-blink{0%,42%,43.55%,100%{opacity:0;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(.05)}42.35%,42.8%{opacity:.95;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(1)}43.15%{opacity:.55;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(.36)}}",
      "@keyframes tk9-dog2-wink{0%,23%,23.31%,100%{opacity:0;transform:rotate(-5deg) scaleY(.05)}23.07%,23.16%{opacity:.95;transform:rotate(-5deg) scaleY(1)}23.23%{opacity:.55;transform:rotate(-5deg) scaleY(.36)}}",
      "@media(max-width:640px){#tk9-dog-offer-teaser2{left:10px;bottom:-5px;width:180px;height:78px}.tk9-dog-offer-teaser2__dog-mask{width:154px;height:53px}.tk9-dog-offer-teaser2__dog{left:0;bottom:-3px;width:145px}#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__dog{left:7px;bottom:-10px;width:136px}.tk9-dog-offer-teaser2__blink{width:19px;height:13px}.tk9-dog-offer-teaser2__blink--left{left:31px;top:17px}.tk9-dog-offer-teaser2__blink--right{left:90px;top:17px}.tk9-dog-offer-teaser2__wink{left:90px;top:17px;width:19px;height:13px}.tk9-dog-offer-teaser2__pill{left:52px;top:8px;min-width:108px;min-height:24px;padding:7px 9px;font-size:8.8px}.tk9-dog-offer-teaser2__close{left:154px;top:-12px;width:48px;height:48px}.tk9-dog-offer-teaser2__close:before{width:18px;height:18px;font-size:10px;box-shadow:0 3px 7px rgba(5,20,30,.14)}}",
      "@media(prefers-reduced-motion:reduce){.tk9-dog-offer-teaser2__blink,.tk9-dog-offer-teaser2__wink{display:none!important;animation:none!important}}"
    ].join("");
    document.head.appendChild(styleTag);
  }

  function ensureDom() {
    if (container && container.isConnected) return;
    ensureStyle();
    var existing = document.getElementById("tk9-dog-offer-teaser2");
    if (existing) existing.remove();
    // Also clear any legacy-generation widget nodes left behind by a
    // cached v40-v45 script that booted before we set its kill switch.
    var legacyRoot = document.getElementById("tk9-dog-offer-button");
    if (legacyRoot) legacyRoot.remove();
    var legacyClose = document.getElementById("tk9-dog-offer-close");
    if (legacyClose) legacyClose.remove();

    container = document.createElement("div");
    container.id = "tk9-dog-offer-teaser2";
    container.className = "is-hidden";
    container.addEventListener("pointerdown", handleCloseHitZone, { capture: true });
    container.addEventListener("touchstart", handleCloseHitZone, { capture: true, passive: false });
    container.addEventListener("mousedown", handleCloseHitZone, { capture: true });

    openButton = document.createElement("button");
    openButton.type = "button";
    openButton.className = "tk9-dog-offer-teaser2__open";
    openButton.setAttribute("aria-label", "Reveal Team K9 welcome offer");
    openButton.innerHTML = [
      '<span class="tk9-dog-offer-teaser2__dog-mask">',
      '<img class="tk9-dog-offer-teaser2__dog" alt="" role="presentation">',
      '<span class="tk9-dog-offer-teaser2__blink tk9-dog-offer-teaser2__blink--left" aria-hidden="true"></span>',
      '<span class="tk9-dog-offer-teaser2__blink tk9-dog-offer-teaser2__blink--right" aria-hidden="true"></span>',
      '<span class="tk9-dog-offer-teaser2__wink" aria-hidden="true"></span>',
      "</span>",
      '<span class="tk9-dog-offer-teaser2__pill" aria-hidden="true"></span>'
    ].join("");
    openButton.addEventListener("pointerdown", handleOpenPointerDown);
    openButton.addEventListener("click", handleOpenClick);

    closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.className = "tk9-dog-offer-teaser2__close";
    closeButton.setAttribute("aria-label", "Hide offer teaser");
    closeButton.addEventListener("pointerdown", handleCloseClick, { capture: true });
    closeButton.addEventListener("touchstart", handleCloseClick, { capture: true, passive: false });
    closeButton.addEventListener("mousedown", handleCloseClick, { capture: true });
    closeButton.addEventListener("click", handleCloseClick, { capture: true });

    container.appendChild(openButton);
    container.appendChild(closeButton);
    document.body.appendChild(container);

    dogImage = openButton.querySelector(".tk9-dog-offer-teaser2__dog");
    pill = openButton.querySelector(".tk9-dog-offer-teaser2__pill");
    pill.textContent = config.label;
    updateDogImage();
  }

  function hideTeaser() {
    if (container) container.classList.add("is-hidden");
  }

  function showTeaser() {
    ensureDom();
    container.classList.remove("is-hidden");
  }

  function applyPlacement() {
    if (!container || container.classList.contains("is-hidden")) return;
    var place = placement();
    var key = [place.left, place.bottom, place.width, place.height].join(":");
    if (key === lastPlacementKey) return;
    lastPlacementKey = key;
    container.style.left = place.left + "px";
    container.style.bottom = place.bottom + "px";
    container.style.width = place.width + "px";
    container.style.height = place.height + "px";
  }

  // ---------- sync loop ----------

  function sync() {
    syncQueued = false;
    if (isDisabled()) {
      hideTeaser();
      releaseBubble();
      return;
    }
    if (isDismissed() && !forceMode) {
      hideTeaser();
      // Session-dismissed means "hide the offer": keep the launcher bubble
      // suppressed too, but never anything larger than a bubble.
      hideBubble();
      return;
    }
    if (popupOpen) {
      hideTeaser();
      releaseBubble();
      return;
    }
    // A visible compact Postscript iframe is its minimized badge. Replace that
    // state with the dog, including on later pages for a previously closed
    // visitor. Expanded/full-screen popup frames never satisfy this check.
    if (isVisibleBubble(document.querySelector(config.frameSelector))) enableReentry();
    if (!popupReady) findPopup();
    if (successActive || isReentryEnabled() || forceMode) {
      showTeaser();
      hideBubble();
      applyPlacement();
    } else {
      // No openable popup (SDK missing/blocked or visitor ineligible):
      // show nothing of ours and leave Postscript's own surfaces alone.
      hideTeaser();
      releaseBubble();
    }
  }

  function runSyncNow() {
    syncQueued = false;
    sync();
  }

  // Coalesce bursty events through rAF, but never depend on rAF for
  // progress: rAF is paused entirely in hidden/backgrounded tabs, so the
  // interval below always calls runSyncNow directly.
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(runSyncNow);
  }

  function boot() {
    if (!document.body) {
      window.setTimeout(boot, 50);
      return;
    }
    ensureDom();
    sync();
    window.setInterval(runSyncNow, config.syncMs);
    document.addEventListener("visibilitychange", runSyncNow);
    window.setInterval(function () {
      if (pendingOpen && popupId && !openVerifyTimer && openAttempt < config.openMaxAttempts) {
        openPopupNow();
        return;
      }
      if (!popupReady && findAttempts < config.findMaxAttempts) findPopup();
    }, config.findRetryMs);
    window.addEventListener("postscriptReady", function () {
      if (pendingOpen && popupId && !openVerifyTimer) openPopupNow();
      findPopup();
      queueSync();
    });
    window.addEventListener("resize", queueSync);
    window.addEventListener("scroll", queueSync, { passive: true });
    window.addEventListener("pageshow", queueSync);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", queueSync);
      window.visualViewport.addEventListener("scroll", queueSync);
    }
    window.addEventListener("message", maybeHandlePostscriptSuccessMessage);
    window.addEventListener("postscriptPopup", handlePostscriptPopupEvent);
    window.addEventListener("tk9DogOfferSuccess", handleSuccessEvent);
    window.addEventListener("teamK9DogOfferSuccess", handleSuccessEvent);

    window.TeamK9DogOfferTeaser = Object.assign(window.TeamK9DogOfferTeaser || {}, {
      version: VERSION,
      showSuccess: showSuccessDog,
      clearSuccess: clearSuccessDog,
      open: handleOpenClick,
      state: function () {
        return {
          version: VERSION,
          popupReady: popupReady,
          popupOpen: popupOpen,
          hasPopupId: Boolean(popupId),
          findAttempts: findAttempts,
          forceMode: forceMode,
          dismissed: isDismissed(),
          reentryEnabled: isReentryEnabled(),
          teaserVisible: Boolean(container && !container.classList.contains("is-hidden")),
          bubblePresent: Boolean(document.querySelector(config.frameSelector)),
          sdkPresent: Boolean(postscriptPopups()),
          placement: placement()
        };
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
